<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>指挥中心</el-breadcrumb-item>
			<el-breadcrumb-item>生产信息统计</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="tool-bar">
			<el-row>
				<el-col :span="20">
					<el-form :inline="true">
						<el-form-item label="维度">
							<el-select v-model="xSeries" placeholder="选择系列（横坐标）" multiple collapse-tags>
								<el-option v-for="item in series" :key="item.value" :label="item.label" :value="item.value"> </el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="指标">
							<el-select v-model="ySeries" placeholder="选择指标（纵坐标）" multiple collapse-tags>
								<el-option v-for="item in quotas" :key="item.value" :label="item.label" :value="item.value"> </el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="时间范围">
							<DateRange v-model="dateRange" :pickerOptions="pickerOptions" />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="makeCharts" :disabled="buttonDisabled">生成统计报表</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="4" style="text-align: right">
					<el-form :inline="true">
						<el-form-item>
							<el-button type="primary" v-on:click="download" :disabled="charts.length == 0" plain>下载Excel</el-button>
							<el-button type="primary" v-on:click="exportToPdf" :disabled="charts.length == 0" :loading="pdfExporting" plain>导出pdf</el-button>
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
		</div>
		<div class="report-view" id="report">
			<div class="report-item" v-for="(item, index) in charts" :key="index">
				<Report :chartType="item.type" v-loading="item.loading" :element-loading-text="item.conditionText" :conditionText="item.conditionText" :table="item.table" :chartData="item.data" />
			</div>
		</div>
	</div>
</template>

<script>
	import DateRange from '@/components/DateRangePicker'
	import Report from './OtherStatReport'
	import moment from 'moment'
	import OtherStat from './OtherStat'
	import XLSX from 'xlsx'
	import { mapGetters } from 'vuex'

	export default {
		components: {
			DateRange,
			Report,
		},
		data() {
			this.quotas = [
				{ label: '产量', value: 1 },
				{ label: '良率（米数）', value: 2 },
				{ label: '良率（张数）', value: 6 },
				{ label: '调机时间', value: 3 },
				{ label: '调机米数', value: 4 },
				{ label: '缺陷', value: 5 },
			]
			this.series = [
				{ label: '设备', value: 1 },
				{ label: '工单', value: 2 },
				{ label: '人员', value: 3 },
				{ label: '工艺', value: 4 },
				{ label: '车间', value: 5 },
				{ label: '班次', value: 6 },
			]

			var self = this

			return {
				xSeries: [],
				ySeries: [],
				dateRange: [],
				dateRangeValue: 0,
				pickerOptions: {
					shortcuts: [
						{
							text: '近十天',
							onClick(picker) {
								const end = new Date()
								const start = moment()
									.subtract(9, 'days')
									.toDate()

								console.log('近十天', start, end)
								picker.$emit('pick', [start, end])
								self.setDateRangeValue(1)
							},
						},
						{
							text: '近六个月',
							onClick(picker) {
								const end = new Date()
								const start = moment()
									.subtract(6, 'months')
									.toDate()

								picker.$emit('pick', [start, end])
								self.setDateRangeValue(2)
							},
						},
						{
							text: '近五年',
							onClick(picker) {
								const end = new Date()
								const start = moment()
									.subtract(6, 'years')
									.toDate()

								picker.$emit('pick', [start, end])
								self.setDateRangeValue(3)
							},
						},
					],
					onPick(maxDate, minDate) {
						console.log('选择：', maxDate, minDate)
						self.setDateRangeValue(0)
					},
				},
				chartTable: {},
				chartData: [],
				chartType: 0,
				conditionText: '',
				loading: false,
				charts: [],
				pdfExporting: false,
			}
		},
		watch: {
			xSeries(val, oldval) {
				if (val.length >= 4) {
					this.$message({
						type: 'error',
						message: '超出个数',
					})
					this.xSeries = oldval
				}
			},
			ySeries(val, oldvlue) {
				if (val.length >= 4) {
					this.$message({
						type: 'error',
						message: '超出个数',
					})
					this.ySeries = oldvlue
				}
			},
		},
		computed: {
			...mapGetters(['userWorkshopId']),
			buttonDisabled() {
				return !(this.xSeries && this.ySeries)
			},
			dateRangeText() {
				var result = ''
				if (this.dateRangeValue == 1) {
					result = '近十天'
				} else if (this.dateRangeValue == 2) {
					result = '近六个月'
				} else if (this.dateRangeValue == 3) {
					result = '近五年'
				} else {
					const st = moment(this.dateRange[0])
					const et = moment(this.dateRange[1])
					result = st.format('yyyy-MM-DD') + '至' + et.format('yyyy-MM-DD')
				}

				return result
			},
		},
		methods: {
			/**
			 * 图表类型。
			 */
			getChartType(ySeries) {
				var val = 0
				switch (ySeries) {
					case 1:
						val = 0
						break
					case 2:
					case 3:
					case 4:
					case 6:
						val = 1
						break
					case 5:
						val = 2
						break
					default:
						break
				}

				return val
			},
			/**
			 * 获取统计条件。
			 */
			getConditions(xSeries, ySeries) {
				var s = this.series.find(t => t.value == xSeries)
				var q = this.quotas.find(t => t.value == ySeries)

				var result = ''
				if (s) {
					result += s.label
				}

				if (q) {
					result += '-' + q.label
				}

				result += ' ' + this.dateRangeText
				return result
			},
			/**
			 * 设置当前日期段。
			 */
			setDateRangeValue(val) {
				this.dateRangeValue = val
			},
			/**
			 * 获取日期分组。
			 */
			getDateRangeGroup() {
				var array = []

				if (this.dateRangeValue == 1) {
					//近十天。
					for (let i = 0; i < 10; i++) {
						const st = moment(this.dateRange[0]).add(i, 'days')
						const et = moment(this.dateRange[0]).add(i + 1, 'days')
						array.push({ startTime: st.valueOf(), endTime: et.valueOf() })
					}
				} else if (this.dateRangeValue == 2) {
					//近6个月。
					for (let i = 0; i < 6; i++) {
						const st = moment(this.dateRange[0]).add(i, 'months')
						const et = moment(this.dateRange[0]).add(i + 1, 'months')
						array.push({ startTime: st.valueOf(), endTime: et.valueOf() })
					}
				} else if (this.dateRangeValue == 3) {
					//近5年。
					for (let i = 0; i < 5; i++) {
						const st = moment(this.dateRange[0]).add(i, 'years')
						const et = moment(this.dateRange[0]).add(i + 1, 'years')
						array.push({ startTime: st.valueOf(), endTime: et.valueOf() })
					}
				} else {
					//自定义日期不进行分段。
					const st = moment(this.dateRange[0])
					const et = moment(this.dateRange[1])
					array.push({ startTime: st.valueOf(), endTime: et.valueOf() })
				}

				return array
			},
			/**
			 * 获取日期列。
			 */
			getDateColumns() {
				var array = []
				if (this.dateRangeValue == 1) {
					//近十天。
					for (let i = 0; i < 10; i++) {
						const st = moment(this.dateRange[0]).add(i, 'days')
						array.push(st.format('yyyy-MM-DD'))
					}
				} else if (this.dateRangeValue == 2) {
					//近6个月。
					for (let i = 1; i <= 6; i++) {
						const st = moment(this.dateRange[0]).add(i, 'months')
						array.push(st.format('yyyy年MM月'))
					}
				} else if (this.dateRangeValue == 3) {
					//近5年。
					for (let i = 1; i <= 5; i++) {
						const st = moment(this.dateRange[0]).add(i, 'years')
						array.push(st.format('yyyy年'))
					}
				} else {
					const st = moment(this.dateRange[0])
					const et = moment(this.dateRange[1])
					array.push(st.format('yyyy-MM-DD') + '至' + et.format('yyyy-MM-DD'))
				}

				return array
			},
			/**
			 * 生成报表。
			 */
			async makeCharts() {
				this.loading = true
				this.charts = []

				//日期分组。
				var dateGroups = this.getDateRangeGroup()
				var chartData = {
					columns: [],
					rows: [],
				}

				var columnNames = []
				var params = []
				var dateColumns = this.getDateColumns()

				//维度。
				for (let i = 0; i < this.xSeries.length; i++) {
					const x = this.xSeries[i]

					//指标。
					for (let j = 0; j < this.ySeries.length; j++) {
						const y = this.ySeries[j]

						this.charts.push({
							key: `${x}-${y}`,
							loading: true,
							type: this.getChartType(y),
							table: {},
							data: [],
							conditionText: this.getConditions(x, y),
						})

						var os = new OtherStat(x, y, dateGroups, this.userWorkshopId)
						os.getData(dateColumns).then(data => {
							var index = this.charts.findIndex(t => t.key == `${x}-${y}`)
							var c = this.charts[index]
							c.table = data.chartTable
							c.data = data.chartData
							c.loading = false

							this.charts[index] = c
						})
					}
				}
				this.loading = false
			},
			chartTableToAoa(chartTable) {
				var aoa = [[...chartTable.columns.map(t => t.text)]]

				chartTable.rows.forEach(row => {
					aoa.push(row.columns.map(t => t.text))
				})

				return aoa
			},
			/**
			 * 下载Excel
			 */
			download() {
				//实例化book
				const wb = XLSX.utils.book_new()

				//遍历统计结果统计图。
				this.charts.forEach(chart => {
					//将表格转aoa格式。
					const aoa = this.chartTableToAoa(chart.table)
					//加入sheet
					const sheet = XLSX.utils.aoa_to_sheet(aoa)
					//追加到excel的sheet中。
					XLSX.utils.book_append_sheet(wb, sheet, chart.conditionText)
				})

				//将blob进行转换。
				const workbookBlob = this.workbook2blob(wb)
				//下载
				this.openDownloadDialog(workbookBlob, `${this.dateRangeText}-${new Date().getTime()}.xlsx`)
			},
			exportToPdf() {
				var fileName = `${this.dateRangeText}-${new Date().getTime()}.pdf`
				//downPdf('report', fileName)
				exportPDF('report', fileName)
			},
			/**
			 *
			 */
			workbook2blob(workbook) {
				function s2ab(s) {
					var buf = new ArrayBuffer(s.length)
					var view = new Uint8Array(buf)
					for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
					return buf
				}

				var wopts = {
					bookType: 'xlsx', // 要生成的文件类型
					bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
					type: 'binary',
				}
				var wbout = XLSX.write(workbook, wopts)
				var blob = new Blob([s2ab(wbout)], {
					type: 'application/octet-stream',
				}) // 字符串转ArrayBuffer

				return blob
			},
			/**
			 * 通用的打开下载对话框方法，没有测试过具体兼容性
			 * @param url 下载地址，也可以是一个blob对象，必选
			 * @param saveName 保存文件名，可选
			 */
			openDownloadDialog(url, saveName) {
				if (typeof url == 'object' && url instanceof Blob) {
					url = URL.createObjectURL(url) // 创建blob地址
				}
				var aLink = document.createElement('a')
				aLink.href = url
				aLink.download = saveName || '' // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
				var event
				if (window.MouseEvent) event = new MouseEvent('click')
				else {
					event = document.createEvent('MouseEvents')
					event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
				}
				aLink.dispatchEvent(event)
			},
		},
		created() {},
	}
</script>

<style lang="less" scoped>
	.header-bar {
		padding: 5px 20px;
		font-size: 13px;
		background-color: #fff;
		border-bottom: 1px #eee solid;
	}
	.tool-bar {
		background-color: #f1f1f1;
		padding: 20px 20px 0;
		margin-top: 20px;
	}

	.report-view {
		padding: 0 20px;
	}

	.report-item {
		border-bottom: 1px #444444 solid;
		padding-bottom: 20px;
		min-height: 300px;
	}

	.report-item:last-child {
		border-bottom: none;
	}
</style>
